import React, { ReactNode, useState } from 'react';
import { Button, Modal } from 'antd';
import './index.scss';
import {
  render as reactRender,
  unmount as reactUnmount,
} from 'rc-util/lib/React/render';

interface ModalProps {
  onClose?: AnyFunc;
  onOk?: AnyFunc;
  visible?: boolean;
  content?: ReactNode;
  title?: ReactNode;
  footer?: {
    showOk?: boolean;
    showCancel?: boolean;
    showCustom?: boolean;
    okText?: string;
    cancelText?: string;
    customText?: string;
    okFunc?: AnyFunc;
    cancelFunc?: AnyFunc;
    customFunc?: AnyFunc;
  } | null;
  style?: React.CSSProperties;
  width?: number;
  okButtonProps?: any;
  className?: string;
}
const CommonModal = (props: ModalProps) => {
  const {
    visible,
    content,
    title,
    footer,
    onOk,
    onClose,
    okButtonProps,
    width,
    style,
    className,
  } = props;
  const [modalVisible, setModalVisible] = useState(visible);
  const handleClose = () => {
    const el = document.getElementById('commonModal');
    if (el) {
      el.parentElement && el.parentElement.removeChild(el);
    }
    setModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      centered
      style={style}
      title={title}
      styles={{ body: { maxHeight: '800px', overflow: 'auto' } }}
      destroyOnHidden={true}
      open={modalVisible}
      maskClosable={false}
      onCancel={handleClose}
      onOk={() => {
        onOk && onOk(handleClose);
      }}
      okButtonProps={okButtonProps}
      className={`common-modal ${className}`}
      footer={
        <>
          {footer?.showCancel && (
            <Button
              onClick={() => {
                footer?.cancelFunc && footer?.cancelFunc(handleClose);
              }}
              style={{ marginRight: '10px' }}
            >
              {footer?.cancelText ?? '取消'}
            </Button>
          )}
          {footer?.showOk && (
            <Button
              type='primary'
              onClick={() => {
                footer?.okFunc && footer?.okFunc(handleClose);
              }}
            >
              {footer?.okText ?? '确定'}
            </Button>
          )}
          {footer?.showCustom && (
            <Button
              type='default'
              style={{ marginLeft: '10px' }}
              onClick={(event) => {
                footer?.customFunc && footer?.customFunc(handleClose);
              }}
            >
              {footer?.customText ?? '报备'}
            </Button>
          )}
        </>
      }
      width={width || 600}
    >
      {content}
    </Modal>
  );
};

export const showModal = (options: ModalProps) => {
  let el = document.getElementById('commonModal');
  if (!el) {
    el = document.createElement('div');
    el.setAttribute('id', 'commonModal');
    document.body.appendChild(el);
  }
  reactRender(
    <CommonModal
      content={options.content}
      onClose={options.onClose}
      onOk={options.onOk}
      okButtonProps={options.okButtonProps || null}
      visible={true}
      title={options.title}
      footer={options.footer}
      width={options.width}
      className={options.className}
    />,
    el,
  );
};
